import { create } from 'zustand';
import type { DiagnosticResult } from '@shared/services/systemDiagnostic';

interface DiagnosticState {
  result: DiagnosticResult | null;
  lastRunForUserId: string | null;
  showHealthyFlash: boolean;
  modalOpen: boolean;

  setResult: (result: DiagnosticResult, userId: string) => void;
  setModalOpen: (open: boolean) => void;
  clearHealthyFlash: () => void;
  reset: () => void;
}

export const useDiagnosticStore = create<DiagnosticState>((set) => ({
  result: null,
  lastRunForUserId: null,
  showHealthyFlash: false,
  modalOpen: false,

  setResult: (result, userId) => set({
    result,
    lastRunForUserId: userId,
    showHealthyFlash: result.status === 'healthy',
  }),
  setModalOpen: (open) => set({ modalOpen: open }),
  clearHealthyFlash: () => set({ showHealthyFlash: false }),
  reset: () => set({ result: null, lastRunForUserId: null, showHealthyFlash: false, modalOpen: false }),
}));
